(function () {
	'use strict';

	var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
	
	window.onload = function () {
		if($('.hs-form').hasClass('hs-custom-style')){
			$('.hs-form').removeClass('hs-custom-style')
		}
	}

})();


